export default __webpack_public_path__ + "static/media/acms-okr.2a87206c.svg";